var exports = {
  "k": "xa15a2ab7--7c327f--container",
};

module.exports = exports;
